// extracted by mini-css-extract-plugin
export default {"root":"BranchDialog_root__bow7K"};